import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'ui/components';

const initialState = {
  barcode: '',
  is_stockable: false,
  is_vatable: false,
  safety_stock: null,
  margin: null,
  base_price: null,
};
export const FormPrice = ({ item, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    { barcode, is_stockable, is_vatable, safety_stock, margin, base_price },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    const input = {
      barcode,
      is_stockable,
      is_vatable,
      safety_stock,
      margin,
      base_price,
    };

    onInputChange(input);
  }, [barcode, is_stockable, is_vatable, safety_stock, margin, base_price]);

  React.useEffect(() => {
    if (!item) return;

    const bp = item?.base_price / (1 + (item?.margin / 100))

    setState((prevState) => ({
      ...prevState,
      barcode: item?.barcode,
      is_stockable: item?.is_stockable,
      is_vatable: item?.is_vatable,
      safety_stock: item?.safety_stock,
      margin: item?.margin,
      base_price: bp,
    }));
  }, [item]);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Informasi Stok dan Harga</div>
      <div className="py-3">
        <Form.Input
          label="Barcode"
          type="text"
          value={barcode}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              barcode: e.target.value,
            }))
          }
          error={StateForm?.errors?.barcode}
        />
        <Form.Input
          label="Harga Dasar"
          type="number"
          value={base_price}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              base_price: e.target.valueNumber,
            }))
          }
          error={StateForm?.errors?.base_price}
        />
        {/* <Form.Input
          label="Margin (%)"
          type="number"
          value={margin}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              margin: e.target.valueNumber,
            }))
          }
          error={StateForm?.errors?.margin}
        /> */}

        <div className="d-flex align-items-center gap-4 mb-3">
          <div>
            <Form.Checkbox
              onChange={() => {
                if (!is_vatable) {
                  setState((prevState) => ({
                    ...prevState,
                    is_vatable: true,
                  }));
                } else {
                  setState((prevState) => ({
                    ...prevState,
                    is_vatable: false,
                  }));
                }
              }}
              iconSize={18}
              value={is_vatable}
              label="Item kena pajak"
            />
          </div>
          {/* <div>
            <Form.Checkbox
              onChange={() => {
                if (!is_stockable) {
                  setState((prevState) => ({
                    ...prevState,
                    is_stockable: true,
                  }));
                } else {
                  setState((prevState) => ({
                    ...prevState,
                    is_stockable: false,
                  }));
                }
              }}
              iconSize={18}
              value={is_stockable}
              label="Item akan di stok"
            />
          </div> */}
        </div>

        {is_stockable && (
          <Form.Input
            required
            label="Safety Stock"
            type="number"
            value={safety_stock}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                safety_stock: e.target.valueNumber,
              }))
            }
            error={StateForm?.errors?.safety_stock}
          />
        )}
      </div>
    </div>
  );
};
